import {BasicCriteria} from '../../framework/parameters/BasicCriteria';

export class DomainCriteria extends BasicCriteria {
uid: string;
}

